import React, { useState } from "react";
import axios from "axios";

const MatchResultUploader = ({ matchId }) => {
  const [screenshot, setScreenshot] = useState(null);
  const [winnerId, setWinnerId] = useState("");

  const handleFileChange = (e) => {
    setScreenshot(e.target.files[0]);
  };

  const handleSubmit = async () => {
    if (!screenshot || !winnerId) {
      alert("Please select a screenshot and enter winner ID.");
      return;
    }

    const formData = new FormData();
    formData.append("result_image", screenshot); // ✅
formData.append("winner_id", winnerId);      // ✅


    try {
       await axios.post(
        `https://backend.aubattle.com/api/admin/complete-match/${matchId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      alert("Result uploaded successfully!");
    } catch (error) {
      console.error("Upload Error:", error.response?.data || error.message);
      alert("Error uploading result.");
    }
  };

  return (
    <div>
      <h4>Upload Match Result</h4>
      <input
        type="text"
        placeholder="Enter Winner ID"
        value={winnerId}
        onChange={(e) => setWinnerId(e.target.value)}
      />
      <br />
      <input type="file" accept="image/png, image/jpeg" onChange={handleFileChange} />
      <button onClick={handleSubmit}>Submit Result</button>
    </div>
  );
};

export default MatchResultUploader;
